import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

import BundleRewards from './BundleRewards/BundleRewards';
import styles from './MainLabelContainer.module.css';
import SingleReward from './SingleReward';
import { Text, Button } from '@betty/moonlight';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { BottomSheet } from '@betty/navigation';
import {
  fetchPromo,
  selectLandingPromoByType,
  selectLandingPromosDataState,
  setClaimPromoButtonVisibility,
} from '@betty/auth';

function MainLabelContainer() {
  const dispatch = useDispatch();
  const welcomePromo = useSelector(selectLandingPromoByType('Welcome'));
  const welcomePromoDataState = useSelector(selectLandingPromosDataState);
  const navigate = useNavigate();

  const ref = useRef(null);

  useEffect(() => {
    if (welcomePromoDataState === 'idle') {
      dispatch(fetchPromo());
    }
  }, [dispatch, welcomePromoDataState]);

  const handleOpenModal = useCallback(() => {
    BottomSheet.open({
      namespace: 'landing',
      type: 'LandingPromoBottomSheet',
      titleKey: 'Welcome Offer',
      data: {
        value: welcomePromo,
      },
      scrollable: true,
    });
  }, [BottomSheet]);

  useEffect(() => {
    let isUnmounting = false;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!isUnmounting) {
          dispatch(setClaimPromoButtonVisibility(entry.isIntersecting));
        }
      },
      {
        threshold: 0.75,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      isUnmounting = true;
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className={styles.mainLabelContainer}>
      <div className={styles.mainLabelWrapper}>
        <div className={`${styles.mainGetLabel} ${styles.mainLabel} `}>
          <Text variant="h4" gradient="darkSurfaceAccent" uppercase>
            Get
          </Text>
        </div>
        {welcomePromo?.rewards?.length ? (
          welcomePromo?.rewards.length === 1 ? (
            <SingleReward reward={welcomePromo.rewards[0]} />
          ) : (
            <BundleRewards rewards={welcomePromo?.rewards} />
          )
        ) : null}
        {welcomePromo?.subTypeMeta?.minimumQualificationAmount ? (
          <Text
            variant="body-s"
            gradient="darkSurfaceAccent"
            textAlign="center"
          >
            for new players with a first deposit of $
            {welcomePromo?.subTypeMeta?.minimumQualificationAmount}
          </Text>
        ) : null}
        <div ref={ref}>
          <Button
            width="100%"
            minWidth={{
              desktop: 320,
              tablet: 320,
              mobile: 270,
            }}
            marginTop={{
              desktop: 'space-200',
              tablet: 'space-200',
              mobile: 'space-300',
            }}
            variant="primary"
            size="large"
            onPress={() => navigate('/register')}
            rightIcon="arrowForward"
            locKey="claimYourBonus"
          />
        </div>
      </div>
      <div className={styles.noWageringWrapper}>
        <Text variant="body-s" color="darkSurfacePrimary">
          Free Spins have no wagering requirements. Withdraw your winnings at
          any time.{' '}
        </Text>
        <Text
          variant="body-s"
          color="darkSurfacePrimary"
          underline
          onPress={handleOpenModal}
        >
          Learn more
        </Text>
      </div>
    </div>
  );
}

export default MainLabelContainer;
